document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initGalerias();
  initVariantesProducto();
});

function initReveals() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-scale');
  if (!els.length) return;

  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-mt-delay') || 0;
          setTimeout(function () {
            entry.target.classList.add('mt-visible');
          }, Number(delay));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  els.forEach(function (el) { observer.observe(el); });
}

function initGalerias() {
  var galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach(function (galeria) {
    var main = galeria.querySelector('[data-mt-galeria-main]');
    var thumbs = galeria.querySelectorAll('[data-mt-galeria-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-mt-full') || thumb.querySelector('img').src;
        var alt = thumb.querySelector('img') ? thumb.querySelector('img').alt : '';
        var img = main.querySelector('img');
        if (img) {
          img.src = src;
          img.alt = alt;
        }
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });
}

function initVariantesProducto() {
  var root = document.querySelector('[data-mt-producto]');
  if (!root) return;

  var dataEl = root.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;

  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var form = root.querySelector('[data-mt-form]');
  var idInput = form ? form.querySelector('input[name="id"]') : null;
  var addBtn = root.querySelector('[data-mt-add-btn]');
  var precioActual = root.querySelector('[data-mt-precio-actual]');
  var precioAnterior = root.querySelector('[data-mt-precio-anterior]');
  var swatchGroups = root.querySelectorAll('[data-mt-opcion-index]');

  function currentSelection() {
    var selection = [];
    swatchGroups.forEach(function (group) {
      var index = Number(group.getAttribute('data-mt-opcion-index'));
      var selected = group.querySelector('.is-selected');
      selection[index] = selected ? selected.getAttribute('data-mt-valor') : null;
    });
    return selection;
  }

  function findVariant(selection) {
    return variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selection[i]; });
    });
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || undefined, {
      style: 'currency',
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR',
    });
  }

  function updateUI() {
    var selection = currentSelection();
    var variant = findVariant(selection);
    if (!variant) return;

    if (idInput) idInput.value = variant.id;

    if (precioActual) {
      try {
        precioActual.textContent = formatMoney(variant.price);
      } catch (e) {
        precioActual.textContent = variant.price_formatted || precioActual.textContent;
      }
    }
    if (precioAnterior) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        precioAnterior.style.display = '';
        try {
          precioAnterior.textContent = formatMoney(variant.compare_at_price);
        } catch (e) {}
      } else {
        precioAnterior.style.display = 'none';
      }
    }

    if (addBtn) {
      if (variant.available) {
        addBtn.disabled = false;
        addBtn.textContent = addBtn.getAttribute('data-mt-label-add');
      } else {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.getAttribute('data-mt-label-soldout');
      }
    }
  }

  swatchGroups.forEach(function (group) {
    var buttons = group.querySelectorAll('[data-mt-valor]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        buttons.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        updateUI();
      });
    });
  });

  updateUI();
}
